module.exports = __webpack_public_path__ + "img/yinhuan1.9e070187.png";